import { MutateOptions, UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";

export type Device = {
  id: string;
  name: number;
  amount: number;
  description: number;
  warranty_period: number;
  payment_type: number;
  system: string;
};

export type BuySell = {
  id: string;
  device_part: number;
  device: Array<Device>;
  amount: number;
  total_price: number;
  content_type: number;
  payment_type: number;
  note: string;
  date: string;
  supplier: number;
};

export interface BuySellListResponse extends Array<BuySell> {}

export interface BuySellModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: BuySell;
  mutate: (
    variables: any,
    options?:
      | MutateOptions<BuySellListResponse, AxiosError<any>, any, unknown>
      | undefined
  ) => void;
}

export interface BuySellAddRequest {
  id?: string;
  name?: string;
  description: string;
  date: Date;
  person_who_assign_id?: string | null | number;
  assingPersonName?: string;
}

export interface BuySellAddResponse {
  name: string;
  description: string;
  date: Date;
  person_who_assign_id: BuySell;
  status: number;
}

export interface BuySellUpdateRequest {
  id?: string;
  name?: string;
  description?: string;
  date?: string;
  person_who_assign?: any;
  person_who_complete?: string | null | number;
  assingPersonName?: string;
}

export interface BuySellUpdateResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface BuySellDeleteRequest {
  id: string;
}

export interface BuySellDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface DeviceBuySellDeleteModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  deviceData?: any;
}

export interface DeviceBuySellDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  deviceData?: any;
}

export interface BuySellDevicePartDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  deviceData?: any;
}

export interface DeviceBuySellDeviceDeleteModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  deviceData?: any;
  buySellDevicePartListMutation: UseMutateFunction<
    BuySellListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export const buySellAddSchema = yup.object().shape({
  name: yup.string().required("İş adı boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  date: yup.date().required("İş tarihi boş bırakılamaz"),
});

export const buySellUpdateSchema = yup.object().shape({
  name: yup.string().required("İş adı boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  date: yup.date().required("İş tarihi boş bırakılamaz"),
});

export const paymentFormatter = (value: number) => {
  if (value == 1) return "Nakit";
  if (value == 2) return "Transfer";
  if (value == 3) return "Kredi Kartı";
  if (value == 4) return "Çek";
  return "Bilinmiyor";
};

export const filtersTypes = [
  { key: "Hepsi", value: 0 },
  { key: "Alış", value: 1 },
  { key: "Satış", value: 2 },
  // { key: "Bakımda Kullanılan", value: 3 },
];

export const contentTypeFormatter = (value: number) => {
  if (value == 1) return "Alış";
  if (value == 2) return "Satış";
  if (value == 3) return "Bakımda Kullanılan";

  return "Bilinmiyor";
};
